import { formatAmount, formatAmountByLocale } from '@alk/numbers';
import { getCurrenciesFromCurrencyPairSafe } from '../core';
import { isNil } from '@alk/core';
function formatCurrencyPairAmount(params, formatter) {
    var _a, _b;
    if (((_a = params.node) === null || _a === void 0 ? void 0 : _a.group) && params.colDef.field === params.node.field) {
        const data = JSON.parse(params.node.key);
        return formatter(data.value);
    }
    else if (Boolean((_b = params.value) === null || _b === void 0 ? void 0 : _b.value)) {
        return formatter(params.value.value);
    }
    else if (!isNil(params.value) && typeof params.value !== 'object') {
        return formatter(Number(params.value));
    }
    else {
        return '';
    }
}
export const getCurrencyFromData = (currencyGetter) => (key) => (params) => {
    const { data } = params.node.group ? params.node.allLeafChildren[0] : params;
    if (!data || !data[key]) {
        return '';
    }
    const currenciesSplit = getCurrenciesFromCurrencyPairSafe(data[key]);
    return Boolean(currenciesSplit) && currencyGetter(currenciesSplit) || '';
};
export function currencyPairAmountCellValueGetter(params) {
    if (params.node.group) {
        return;
    }
    const amount = params.data[params.colDef.field];
    const cellRendererParams = params.colDef
        .cellRendererParams;
    const currencyPair = params.data[cellRendererParams.currenciesSplitKey];
    let currency = '';
    if (Boolean(currencyPair)) {
        const currenciesSplit = getCurrenciesFromCurrencyPairSafe(currencyPair);
        currency = Boolean(currenciesSplit) && cellRendererParams.getCurrencyFromCurrenciesSplit(currenciesSplit) || '';
    }
    // eslint-disable-next-line consistent-return
    return {
        value: amount,
        currency,
        toString: function () {
            var _a;
            return (_a = this.value) !== null && _a !== void 0 ? _a : '';
        },
    };
}
export function currencyPairAmountCellValueFormatter(params) {
    return formatCurrencyPairAmount(params, formatAmount);
}
export function currencyPairAmountWithPrecisionCellFormatter(params) {
    const precisionDigits = params.colDef.cellRendererParams.precisionDigits;
    const formatter = formatAmountByLocale(navigator.language)(precisionDigits)(precisionDigits);
    return formatCurrencyPairAmount(params, formatter);
}
export function currencyPairAmountCellComparator(valueA, valueB) {
    if (!Boolean(valueA === null || valueA === void 0 ? void 0 : valueA.value) && !Boolean(valueB === null || valueB === void 0 ? void 0 : valueB.value)) {
        return 0;
    }
    if (!Boolean(valueA === null || valueA === void 0 ? void 0 : valueA.value) && (valueA === null || valueA === void 0 ? void 0 : valueA.value) !== 0) {
        return -1;
    }
    if (!Boolean(valueB === null || valueB === void 0 ? void 0 : valueB.value) && (valueB === null || valueB === void 0 ? void 0 : valueB.value) !== 0) {
        return 1;
    }
    return Math.sign(Number(valueA.value) - Number(valueB.value));
}
export function currencyFixedAmountCellValueGetter(params) {
    if (params.node.group) {
        return;
    }
    const amount = params.data[params.colDef.field];
    const currency = params.colDef.cellRendererParams.fixedCurrency;
    const underlying = params.data[params.colDef.cellRendererParams.underlyingKey];
    // eslint-disable-next-line consistent-return
    return Object.assign(Object.assign({ value: amount, currency }, (Boolean(underlying) ? { underlying } : {})), { toString: function () {
            var _a;
            return (_a = this.value) !== null && _a !== void 0 ? _a : '';
        } });
}
export function currencyKeyedAmountCellValueGetter(params) {
    if (params.node.group) {
        return;
    }
    const amount = params.data[params.colDef.field];
    const currency = params.data[params.colDef.cellRendererParams.currencyKey];
    const underlying = params.data[params.colDef.cellRendererParams.underlyingKey];
    if (!(Boolean(amount) || amount === 0)) {
        // eslint-disable-next-line consistent-return
        return undefined;
    }
    // eslint-disable-next-line consistent-return
    return Object.assign(Object.assign({ value: amount, currency }, (Boolean(underlying) ? { underlying } : {})), { toString: function () {
            var _a, _b;
            return (_b = (_a = this.value) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : '';
        } });
}
